import store from '@/store';

/**
 * 按钮权限指令：v-permission="'user:add'" 或 v-permission="['user:add', 'user:edit']"
 * 如果当前用户没有对应权限，则移除该 DOM 元素
 */
export default {
  inserted(el, binding) {
    const { value } = binding;
    if (!value) return;
    
    // 获取当前页面的权限码列表（从 Vuex 中读取）
    const pagePermissions = store.state.user.permissions || [];
    
    let hasPermission = false;
    if (Array.isArray(value)) {
      hasPermission = value.some(perm => pagePermissions.includes(perm));
    } else {
      hasPermission = pagePermissions.includes(value);
    }
    
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
};